module.exports = __webpack_public_path__ + "static/media/productos_otros_pepita_blanca.ae0a3771.png";